
export default {
  data() {
    return {
      clients: null
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this

    this.clients = await $content(locale, 'shop/clients')
      .where({ active: true })
      .sortBy('order')
      .fetch()
  }
}
